import dayjs from "dayjs";

export const formatDate = (isoDateString: string) => {
  const date = new Date(isoDateString);

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear().toString().slice(-2);

  const formattedDate = `${day.toString().padStart(2, "0")}.${month
    .toString()
    .padStart(2, "0")}.${year}`;

  return formattedDate;
};

export const formatIsoDate = (
  isoDateString: string,
  format: "month" | "full" | "time" | "timeWithSeconds" = "full"
) => {
  const date = dayjs(isoDateString);

  if (format === "time") {
    return date.format("HH:mm");
  }

  if (format === "timeWithSeconds") {
    return date.format("HH:mm:ss");
  }

  if (format === "month") {
    return date.format("YYYY-MM");
  }

  return date.format("YYYY-MM-DD");
};

export const formatDateTime = (
  isoDateString: string,
  separator: " в" | "," = " в"
) => {
  const d = new Date(isoDateString);
  const day = d.getDate().toString().padStart(2, "0");
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const year = d.getFullYear();
  const hours = d.getHours().toString().padStart(2, "0");
  const minutes = d.getMinutes().toString().padStart(2, "0");

  return `${day}.${month}.${year}${separator} ${hours}:${minutes}`;
};

export const formatTime = (isoDateString: string) => {
  const date = new Date(isoDateString);
  const hours = date.getUTCHours().toString().padStart(2, "0");
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");
  return `${hours}:${minutes}`;
};

export const formatToLocalTime = (isoDateString: string) => {
  const date = new Date(isoDateString);
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  return `${hours}:${minutes}`;
};

export function toUTCStartOfDay(dateString: string) {
  const [year, month, day] = dateString.split("-").map(Number);
  const d = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
  return d.toISOString();
}

export function toUTCEndOfDay(dateString: string) {
  const [year, month, day] = dateString.split("-").map(Number);
  const d = new Date(Date.UTC(year, month - 1, day, 23, 59, 59, 999));
  return d.toISOString();
}

export function toUTCYearMonth(dateString: string) {
  const [year, month] = dateString.split("-").map(Number);
  return `${year}-${String(month).padStart(2, "0")}`;
}

export function toDateFormat(dateString: string) {
  const [year, month, day] = dateString.split("-").map(Number);
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
    2,
    "0"
  )}`;
}

export function toYearMonthFormat(dateString: string) {
  const [year, month] = dateString.split("-").map(Number);
  return `${year}-${String(month).padStart(2, "0")}`;
}

export function toUTCWithTime(dateString: string, timeString?: string) {
  const [year, month, day] = dateString.split("-").map(Number);

  if (timeString) {
    const [hours, minutes] = timeString.split(":").map(Number);
    const d = new Date(Date.UTC(year, month - 1, day, hours, minutes, 0));
    return d.toISOString();
  } else {
    const d = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
    return d.toISOString();
  }
}

export function toUTCEndOfDayWithTime(dateString: string, timeString?: string) {
  const [year, month, day] = dateString.split("-").map(Number);

  if (timeString) {
    const [hours, minutes] = timeString.split(":").map(Number);
    const d = new Date(Date.UTC(year, month - 1, day, hours, minutes, 59, 999));
    return d.toISOString();
  } else {
    const d = new Date(Date.UTC(year, month - 1, day, 23, 59, 59, 999));
    return d.toISOString();
  }
}

// Action logs and their date filters use UTC, independently of browser timezone.
export const formatLogDateTimeUTC = (value: string): string => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Нет данных";
  return new Intl.DateTimeFormat("ru-RU", {
    timeZone: "UTC", year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
  }).format(date);
};
